import { InfoCircleOutlined } from "@ant-design/icons";
import { Modal, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { CopyClipboardIcon } from "../../assets/svg";
import { AdvancedLoader } from "../../components/advanced-loader";
import { Config } from "../../config";
import { APIStatus } from "../../constants";
import { useAppDispatch, useAppSelector } from "../../modal/hooks";
import { Share } from "../../plugins/icons";
import { getIndividualLink, shareLinkViaMail } from "../../services/results/results.service";
import { clearIndividualTokenCompleted } from "../../services/results/results.slice";
import { encryptionPrefix, showSuccess } from "../../utils/util.fns";

interface ComponentType {
	handleCancel: () => void;
	propsData: any;
}
const ReScheduleModal: React.FunctionComponent<ComponentType> = (props) => {
	const dispatch = useAppDispatch();
	const getIndividualTokenCompleted = useAppSelector((store) => store.results.getIndividualTokenCompleted);
	const getIndividualToken = useAppSelector((store) => store.results.token);
	const isNegativeMark = useAppSelector((store) => store.settings.isNegativeMark);

	const studentId = props.propsData.data.id;

	const encryptId = encodeURIComponent(btoa(studentId));

	const link = `${Config.siteUrl}/${getIndividualToken}${encryptionPrefix}${encryptId}/instructions`;

	const [state, setState] = useState<{ showLink: boolean; loading: boolean }>({ showLink: false, loading: false });

	useEffect(() => {
		if (getIndividualTokenCompleted === APIStatus.FULFILLED) {
			setState((prestate) => ({ ...prestate, showLink: true, loading: false }));
			dispatch(clearIndividualTokenCompleted());
		}
		if (getIndividualTokenCompleted === APIStatus.REJECTED) {
			setState((prestate) => ({ ...prestate, loading: false }));
			dispatch(clearIndividualTokenCompleted());
		}
	}, [getIndividualTokenCompleted]);

	const handleGenerateLink = () => {
		setState((prestate) => ({ ...prestate, loading: true }));
		dispatch(getIndividualLink(props.propsData?.data?.id));
	};

	const handleCopyLink = () => {
		const token = link;
		if (token) {
			navigator.clipboard
				.writeText(token)
				.then(() => {
					showSuccess("Exam link copied to clipboard");
				})
				.catch((err) => {
					console.error("Failed to copy: ", err);
				});
		}
	};

	const handleClose = () => {
		setState((prestate) => ({ ...prestate, showLink: false }));
		props.handleCancel();
	};

	const handleSendMail = () => {
		const payload = {
			student: {
				email: props.propsData?.data?.email,
				name: props.propsData?.data?.name,
			},
			examUrl: link,
		};
		dispatch(shareLinkViaMail(payload));
	};

	return (
		<Modal
			title={
				<div className="d-flex align-items-center">
					Examination Link
					<Tooltip title={`Negative marks ${isNegativeMark ? "enabled" : "disabled"}`}>
						<InfoCircleOutlined style={{ fontSize: 21, marginLeft: 8, cursor: "pointer", color: "#f15623" }} />
					</Tooltip>
				</div>
			}
			open={props.propsData?.isOpen}
			className="generate_link_pop_up_screen"
			onCancel={handleClose}
			closable={true}
			footer={null}
		>
			<div className="generate_link_box_content px-4 mb-2">
				{!state.showLink ? (
					<div className="button_container d-flex flex-column">
						<div className="font_regular text_color pl-1 min_height_85">
							<div className="font_16">
								Once the exam link is generated, no additional questions can be added for the next exam session.
							</div>
							<div className="font_16">Are you sure you want to reschedule the exam link?</div>
							<div className="d-flex align-items-center justify-content-end pr-3">
								<button
									className="secondary_border_btn font_15 min_height_34 min_width_150 mr-1"
									disabled={state.loading}
									onClick={handleClose}
								>
									Cancel
								</button>
								<button
									className="primary_btn font_15 min_width_170 min_height_34 ml-2"
									disabled={state.loading}
									onClick={handleGenerateLink}
								>
									{state.loading ? <AdvancedLoader /> : <span>Generate Exam Link</span>}
								</button>
							</div>
						</div>
					</div>
				) : (
					<>
						<div className="generate_link_sub_header mb-1 pl-1">You may share the link to initiate the exam.</div>
						<div className="d-flex align-items-center w-100">
							<div className="generate_link text-break">{link}</div>
							<Tooltip title="Copy link" placement="top">
								<div className="button_container">
									<div className="button_container icon_container icon_button cursor_pointer" onClick={handleCopyLink}>
										<CopyClipboardIcon />
									</div>
								</div>
							</Tooltip>
							<Tooltip title="Send via mail" placement="top">
								<div className="button_container">
									<div className="button_container icon_container icon_button cursor_pointer" onClick={handleSendMail}>
										<Share />
									</div>
								</div>
							</Tooltip>
							{/* <button
								className="primary_border_btn font_16 min_width_120 ml-2 send_button"
								onClick={handleSendMail}
							>
								Share
							</button> */}
						</div>
					</>
				)}
			</div>
		</Modal>
	);
};

export default ReScheduleModal;
